import type { Component } from 'vue';

import { contextualError } from '@/shared/utils/error';

export const mountProductTab = (
  tabComponent: Component,
  mountSelector: string,
  boundTabSelector: string,
  mounter: {
    (
      component: Component,
      target: HTMLElement,
      props?: Record<string, unknown>
    ): Promise<void>;
  },
  props?: Record<string, unknown>
) => {
  // Set up a mutation observer for the target elements (tabs), to initialize when becoming "active".
  const attrObserver = new MutationObserver((mutations) => {
    mutations.forEach((mu) => {
      if (mu.type !== 'attributes' && mu.attributeName !== 'class') return;

      const menuItem = mu.target as HTMLElement;

      if (menuItem.classList.contains('js-active')) {
        const targetMountElement =
          menuItem.querySelector<HTMLElement>(mountSelector);

        if (
          targetMountElement &&
          !targetMountElement.hasAttribute('data-v-app')
        ) {
          mounter(tabComponent, targetMountElement, props).catch((error) => {
            throw contextualError(
              'tab-mounter',
              `Unable to mount ${tabComponent.name}`,
              error
            );
          });
        }
      }
    });
  });

  const targetElement = document.querySelector(boundTabSelector);

  if (targetElement) {
    attrObserver.observe(targetElement, { attributes: true });
  }
};
